import React from 'react';
import { Row, Column } from 'react-foundation';

const Theme = (props) => {
	const handleClick = () => {
		props.myOnClick(props.theme);
	};

	return (
		<div
			id={props.id}
			className={'theme card' + (props.active ? ' active' : '')}
			onClick={handleClick}
		>
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<div
					className={'theme-title ' + (props.active ? ' active' : '')}
				>
					{props.theme.name}
				</div>

				<div
					className={
						'theme-text score-holder' +
						(props.active ? ' active' : '')
					}
				>
					<div className="medium-only">Engagement:</div>
					<span>{' ' + props.theme.engagement_score} </span>
				</div>

				<div
					className={
						'theme-text score-holder' +
						(props.active ? ' active' : '')
					}
				>
					<div className="medium-only">Opportunity:</div>
					<span className={props.mask_content ? ' blur' : ''}>
						{props.mask_content
							? '00'
							: ' ' + props.theme.opportunity_score}
					</span>
				</div>

				<div
					className={
						'theme-text flex-1' + (props.active ? ' active' : '')
					}
				>
					{props.theme.location}
				</div>
			</div>
		</div>
	);
};

export default Theme;
